import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types/api';
import { Include } from '../types/Include';

const URL = '/v2/booking-includes';

class IncludeService {
  static getBookingIncludes(
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<Include>> {
    return axios.get(URL, config);
  }

  static getByFilterForAdmin(
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<Include>> {
    return axios.get(`${URL}?includeDisabled=true`, config);
  }

  static patch(
    id: number,
    data: Include,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<Include>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }

  static update(
    id: number,
    data: Include,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<Include>> {
    return axios.put(`${URL}/${id}`, data, config);
  }

  static create(
    data: Include,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<Include>> {
    return axios.post(URL, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig) {
    return axios.delete(`${URL}/${id}`, config);
  }
}

export { IncludeService };
